module.exports = __webpack_public_path__ + "static/media/Team_etud.127d7010.svg";